import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NbDialogService } from '@nebular/theme';
import { AutomationService, AutomationCampaign, CampaignMetrics } from '../../../service/automation.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-automation',
  standalone: false,
  templateUrl: './automation.component.html',
  styleUrls: ['./automation.component.scss'],
})
export class AutomationComponent implements OnInit {
  campaigns: AutomationCampaign[] = [];
  loading = true;
  selectedCampaign: AutomationCampaign | null = null;
  metrics: CampaignMetrics | null = null;
  metricsLoading = false;

  @ViewChild('previewDialog') previewDialogTpl!: TemplateRef<any>;
  previewUrl: SafeResourceUrl | null = null;

  constructor(
    private automationService: AutomationService,
    private dialogService: NbDialogService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadCampaigns();
  }

  loadCampaigns(): void {
    this.loading = true;
    this.automationService.getCampaigns().subscribe({
      next: (campaigns) => {
        this.campaigns = campaigns;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  selectCampaign(campaign: AutomationCampaign): void {
    this.selectedCampaign = campaign;
    this.metrics = null;
    this.metricsLoading = true;
    this.automationService.getCampaignMetrics(campaign.id).subscribe({
      next: (m) => { this.metrics = m; this.metricsLoading = false; },
      error: () => { this.metricsLoading = false; },
    });
  }

  openPreview(campaign: AutomationCampaign): void {
    if (!campaign.preview_img_url) return;
    this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(campaign.preview_img_url);
    this.dialogService.open(this.previewDialogTpl, { hasBackdrop: true });
  }

  editInGenerator(campaign: AutomationCampaign): void {
    if (campaign.generate_html_id) {
      localStorage.setItem('editor_previous_url', this.router.url);
      this.router.navigate(['/pages/generator-v2', campaign.generate_html_id]);
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'ACTIVE': return 'status-active';
      case 'PAUSED': return 'status-paused';
      case 'STOPPED': return 'status-stopped';
      default: return '';
    }
  }

  pauseCampaign(campaign: AutomationCampaign): void {
    this.automationService.pauseCampaign(campaign.id).subscribe(() => {
      campaign.status = 'PAUSED';
    });
  }

  resumeCampaign(campaign: AutomationCampaign): void {
    this.automationService.resumeCampaign(campaign.id).subscribe(() => {
      campaign.status = 'ACTIVE';
      campaign.auto_paused = false;
    });
  }

  stopCampaign(campaign: AutomationCampaign): void {
    if (confirm(`Arreter definitivement la campagne "${campaign.name}" ?`)) {
      this.automationService.stopCampaign(campaign.id).subscribe(() => {
        campaign.status = 'STOPPED';
      });
    }
  }

  deleteCampaign(campaign: AutomationCampaign): void {
    if (confirm(`Supprimer definitivement la campagne "${campaign.name}" ?`)) {
      this.automationService.deleteCampaign(campaign.id).subscribe(() => {
        this.campaigns = this.campaigns.filter((c) => c.id !== campaign.id);
        if (this.selectedCampaign?.id === campaign.id) {
          this.selectedCampaign = null;
        }
      });
    }
  }

  getRunStatusIcon(status: string): string {
    switch (status) {
      case 'COMPLETED': return '✓';
      case 'FAILED': return '✗';
      case 'RUNNING': return '⟳';
      case 'SKIPPED': return '—';
      default: return '○';
    }
  }
}
